import React,{useState , useEffect} from 'react'
import "./Map.scss"

export default function Map() {
    const [open, setOpen] = useState(false)
    const [open2, setOpen2] = useState(false)
    const [open3, setOpen3] = useState(false)
    const [open4, setOpen4] = useState(false)
    const [open5, setOpen5] = useState(false)
    const [open6, setOpen6] = useState(false)
    const [open7, setOpen7] = useState(false)
    const [open8, setOpen8] = useState(false)
    const [open9, setOpen9] = useState(false)

    function handleClick(e){
        // e.target.classList.remove("closed")
        // let classes = e.target.classList.value;
        // // console.log(classes.contains(""))
        // if(e.target.classList.value.includes("open")){
        //     e.target.classList.add("closed")
        //     e.target.classList.toggle("open")
        // }
    }
    useEffect(() => {
        //Sets the Observer options
        const options = {
          root: null, // The view port
          threshhold: 0.5, // 0 ~ 1
          rootMargin: "0px", // like margin in css
        };
        const observer = new IntersectionObserver(function (entries, observer) {
          entries.forEach((entry) => {
            if (!entry.isIntersecting)return;
                entry.target.classList.add("vibe")
            })
        }, options);
        const wantedNodes = document.querySelectorAll(".hand");
        wantedNodes.forEach((li) => {
          observer.observe(li);
        });
      }, []);

    return (
        <section className="map_sec watch">
            <div className="map_credit">צילום: דוד רובינגר, נתונים: צחי דבירה</div>
            <div className="hand_wrapper">
                <div className="hand"></div>
            </div>
            <div className="map">
                <div className={`dot dot_1 ${open ? "open" : "closed"}`} onClick={() => setOpen(!open)}><i class="fas fa-times"></i></div>
                <div className={`dot dot_2 ${open2 ? "open" : "closed"}`} onClick={() => setOpen2(!open2)}><i class="fas fa-times"></i></div>
                <div className={`dot dot_3 ${open3 ? "open" : "closed"}`} onClick={() => setOpen3(!open3)}><i class="fas fa-times"></i></div>
                <div className={`dot dot_4 ${open4 ? "open" : "closed"}`} onClick={() => setOpen4(!open4)}><i class="fas fa-times"></i></div>
                <div className={`dot dot_5 ${open5 ? "open" : "closed"}`} onClick={() => setOpen5(!open5)}><i class="fas fa-times"></i></div>
                <div className={`dot dot_6 ${open6 ? "open" : "closed"}`} onClick={() => setOpen6(!open6)}><i class="fas fa-times"></i></div>
                <div className={`dot dot_7 ${open7 ? "open" : "closed"}`} onClick={() => setOpen7(!open7)}><i class="fas fa-times"></i></div>
                <div className={`dot dot_8 ${open8 ? "open" : "closed"}`} onClick={() => setOpen8(!open8)}><i class="fas fa-times"></i></div>
                <div className={`dot dot_9 ${open9 ? "open" : "closed"}`} onClick={() => setOpen9(!open9)}><i class="fas fa-times"></i></div>
            </div>
        </section>
    )
}
